export default __webpack_public_path__ + "static/media/ergocareComfort.8dfb175b.jpg";